import { optionTitle_publishACalendar } from './PublishedCalendarsOption.locstring.json';
import { LazyModule } from 'owa-bundling';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
import { createLazyOption, LazyOption } from 'owa-options-core';

var lazyFullModule = new LazyModule(() => import('./lazyFullPublishedCalendarsOption'));
const PublishedCalendarsOption: LazyOption = createLazyOption(
    {
        key: 'publishedCalendars',
        titleStringKey: optionTitle_publishACalendar,
        searchTermsStringKey: optionTitle_publishACalendar,
        isHidden: () => IsShadowMailboxUser(),
        allowedOptionKeys: ['CalendarPublishing'],
    },
    lazyFullModule,
    m => m.default
);
export default PublishedCalendarsOption;
